/**
 * CreatureClassType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file CreatureClassType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum  CreatureClassType {
  SOLDIER       =   0,
  SCOUT         =   1,
  SCOUNDREL     =   2,
  JEDIGUARDIAN  =   3,
  JEDICONSULAR  =   4,
  JEDISENTINEL  =   5,
  COMBATDROID   =   6,
  EXPERTDROID   =   7,
  MINION        =   8,
  INVALID        = 255,
}